export const SUIT_SYMBOL = { Cuori: "♥", Quadri: "♦", Fiori: "♣", Picche: "♠" };
export const SUIT_COLOR = {
  Cuori: "#D71920",
  Quadri: "#D71920",
  Fiori: "#111111",
  Picche: "#111111",
};
export const SUIT_LABEL = { Cuori: "CUORI", Quadri: "QUADRI", Fiori: "FIORI", Picche: "PICCHE" };
export const SUIT_ORDER_MEN = ["Picche", "Fiori", "Quadri", "Cuori"];
export const SUIT_ORDER_WOMEN = ["Fiori", "Cuori"];
